// extracted by mini-css-extract-plugin
export var modal = "_ji-0";